export default function Footer() {
  return (
    <footer className="bg-black text-white px-4 py-8 text-sm">
      {/* Top links */}
      <div className="flex justify-center space-x-8 border-b border-gray-600 pb-4 mb-6">
        <a href="/contact" className="hover:underline">
          Contact Us
        </a>
        <a
          href="https://www.google.com/search?sca_esv=950f1dd50efd152d&sxsrf=AE3TifNwSW_fUp08MN5yfdKV4l2G1Scq3w:1754486509906&si=AMgyJEuzsz2NflaaWzrzdpjxXXRaJ2hfdMsbe_mSWso6src8s4OXHm23HIIUhRPpcuBKqOjvgtnW0Sg6ZLFUa2EjX8L2djBwNH_Ik7zc1_M5IvbKrzkAso2oESluLSM0QtDFIbUiDSpZrdBFZMJ7Ncf2sPwAP8jgSg%3D%3D&q=Price+Bros+Equipment+Co+Reviews&sa=X&ved=2ahUKEwjdrb7Jo_aOAxX4kmoFHfFMEV4Q0bkNegQIJhAE&biw=1869&bih=919&dpr=1"
          className="hover:underline"
          target="_blank"
        >
          Customer Reviews
        </a>
        <a href="/privacy-policy" className="hover:underline">
          Privacy policy
        </a>
      </div>

      {/* Main footer content */}
      <div className="flex flex-col lg:flex-row justify-between items-center lg:items-start max-w-screen-xl mx-auto">
        {/* Left: Address */}
        <div className="text-left mb-6 lg:mb-0">
          <h4 className="font-bold text-lg mb-1">PRICE BROS EQUIPMENT</h4>
          <p className="italic">
            619 S. Washington
            <br />
            P.O. Box 3207
            <br />
            Wichita, KS 67201-3207
          </p>
          <p className="mt-2">
            <a href="tel:+13162659577" className="italic hover:underline">
              (316) 265-9577
            </a>
            <br />
            <a href="mailto:parts@pricebroseq.com" className="hover:underline">
              parts@pricebroseq.com
            </a>
          </p>
          <p className="mt-2">
            Prices and availability subject to change without notice.
          </p>
        </div>

        {/* Center: Mailing list */}
        <div className="mb-6 lg:mb-0">
          {/* <p className="mb-2 text-center lg:text-left">Join Our Mailing List</p>
          <TextInput
            type="email"
            placeholder="Your email"
            className="w-64 text-black"
          /> */}
        </div>

        {/* Right: Social icons and logo */}
        <div className="text-center lg:text-right">
          <p className="mb-2">Follow us</p>
          <div className="flex justify-center lg:justify-end space-x-4 mb-4">
            <a href="https://www.facebook.com/PriceBrosEqAG/">
              <img src="/assets/facebook-48.png" className="w-6" />
            </a>
            <a href="https://www.instagram.com/pricebrosequipment_wichita/">
              <img src="/assets/instagram-48.png" className="w-6" />
            </a>
            <a href="https://www.youtube.com/PriceBrosEqAG">
              <img src="/assets/youtube-48.png" className="w-6" />
            </a>
          </div>
          <p className="mb-1">Proud Members of:</p>
          <div className="bg-white p-2 rounded shadow-md inline-block">
            <img
              src="/assets/EMDA.png"
              alt="EMDA"
              className="h-12 mx-auto lg:mx-0"
            />
          </div>
        </div>
      </div>
    </footer>
  );
}
